import { View } from "@react-pdf/renderer";
import { tableStyles } from "./SmartTitanProjektPDF";
import { DataTableAASHTOHeader } from "./DataTableAASHTOHeader";
import { DataTableAASHTOFooter } from "./DataTableAASHTOFooter";
import { DataTableAASHTODataRow } from "./DataTableAASHTODataRow";

export function DataTableAASHTO({ data, item, tableInput, tableCalculated, sumRsdi, lreq }) {
  return (
    <View style={tableStyles.tableContainer}>
      {/* TableHeader */}

      <DataTableAASHTOHeader item={item} />

      {tableInput.map((row, index) => {
        return (
          <DataTableAASHTODataRow
            key={index}
            index={index}
            tableInput={tableInput}
            tableCalculated={tableCalculated}
          />
        );
      })}

      {/* Table footer */}
      <DataTableAASHTOFooter item={item} sumRsdi={sumRsdi} lreq={lreq} />
    </View>
  );
}
